import { render } from "./DataItem.vue?vue&type=template&id=0b3d1c79&scoped=true"
import script from "./DataItem.vue?vue&type=script&lang=js"
export * from "./DataItem.vue?vue&type=script&lang=js"

import "./DataItem.vue?vue&type=style&index=0&id=0b3d1c79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3d1c79"]])

export default __exports__